import React, { useState, useEffect } from 'react';
import './AdminReporte.css';
import config, { getApiUrl } from './config';

export default function AdminReporte({ onLogout, usuarioLogueado, onNavigate }) {
  const [reservas, setReservas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState('');
  const [filtroFechaDesde, setFiltroFechaDesde] = useState('');
  const [filtroFechaHasta, setFiltroFechaHasta] = useState('');
  const [filtroEmail, setFiltroEmail] = useState('');

  useEffect(() => {
    cargarReservas();
  }, []);

  const cargarReservas = async () => {
    setCargando(true);
    setError('');
    try {
      const response = await fetch(getApiUrl('/admin/reservas'), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });
      
      const data = await response.json();
      if (data.success) {
        setReservas(data.reservas);
      } else {
        setError(data.message || 'Error al cargar las reservas');
      }
    } catch (error) {
      setError('Error de conexión al servidor');
    } finally {
      setCargando(false);
    }
  };

  const filtrarReservas = () => {
    if (!reservas) return [];
    
    console.log('=== INICIO FILTRADO ===');
    console.log('Total reservas:', reservas.length);
    console.log('Filtros:', { filtroFechaDesde, filtroFechaHasta, filtroEmail });
    
    // Si no hay filtros activos, devolver todas las reservas
    if (!filtroFechaDesde && !filtroFechaHasta && !filtroEmail) {
      console.log('Sin filtros activos, devolviendo todas las reservas');
      return reservas;
    }
    
    // Preparar fechas de filtro
    let fechaDesdeObj = null;
    if (filtroFechaDesde) {
      fechaDesdeObj = new Date(filtroFechaDesde + 'T00:00:00');
      console.log('Fecha desde objeto:', fechaDesdeObj);
    }
    
    let fechaHastaObj = null;
    if (filtroFechaHasta) {
      fechaHastaObj = new Date(filtroFechaHasta + 'T23:59:59');
      console.log('Fecha hasta objeto:', fechaHastaObj);
    }
    
    const reservasFiltradas = reservas.filter(reserva => {
      console.log('\n--- Evaluando reserva ID:', reserva.id, '---');
      console.log('fechaCreacion original:', reserva.fechaCreacion);
      
      // Si la reserva no tiene fechaCreacion, la incluimos siempre
      if (!reserva.fechaCreacion) {
        console.log('❌ Sin fechaCreacion - INCLUIDA');
        return true;
      }
      
      try {
        // Convertir la fecha de creación a objeto Date
        const fechaCreacionStr = reserva.fechaCreacion;
        const fechaCreacionObj = new Date(fechaCreacionStr);
        
        console.log('fechaCreacion como Date:', fechaCreacionObj);
        console.log('fechaCreacion válida:', !isNaN(fechaCreacionObj.getTime()));
        
        // Verificar si la fecha es válida
        if (isNaN(fechaCreacionObj.getTime())) {
          console.log('❌ Fecha inválida - INCLUIDA');
          return true;
        }
        
        let cumpleFiltros = true;
        
        // Aplicar filtro desde
        if (fechaDesdeObj) {
          const cumpleDesde = fechaCreacionObj >= fechaDesdeObj;
          console.log('Filtro DESDE:', fechaCreacionObj, '>=', fechaDesdeObj, '=', cumpleDesde);
          if (!cumpleDesde) {
            cumpleFiltros = false;
          }
        }
        
        // Aplicar filtro hasta
        if (fechaHastaObj) {
          const cumpleHasta = fechaCreacionObj <= fechaHastaObj;
          console.log('Filtro HASTA:', fechaCreacionObj, '<=', fechaHastaObj, '=', cumpleHasta);
          if (!cumpleHasta) {
            cumpleFiltros = false;
          }
        }

        // Aplicar filtro por email (coincidencia parcial, case-insensitive)
        if (filtroEmail) {
          const emailReserva = (reserva.email || '').toLowerCase();
          const emailFiltro = filtroEmail.toLowerCase();
          const cumpleEmail = emailReserva.includes(emailFiltro);
          console.log('Filtro EMAIL:', emailReserva, 'incluye', emailFiltro, '=', cumpleEmail);
          if (!cumpleEmail) {
            cumpleFiltros = false;
          }
        }
        
        console.log('Resultado final:', cumpleFiltros ? '✅ INCLUIDA' : '❌ EXCLUIDA');
        return cumpleFiltros;
        
      } catch (error) {
        console.error('❌ Error al procesar fecha:', error);
        return true;
      }
    });
    
    console.log('=== FIN FILTRADO ===');
    console.log('Reservas filtradas:', reservasFiltradas.length);
    return reservasFiltradas;
  };

  const formatearFecha = (fechaStr) => {
    if (!fechaStr) return '';
    const fecha = new Date(fechaStr);
    return fecha.toLocaleDateString('es-ES');
  };

  const reservasFiltradas = filtrarReservas();
  const emailsUnicos = Array.from(new Set((reservas || []).map(r => r.email).filter(Boolean))).sort();

  const descargarExcel = () => {
    try {
      const datos = filtrarReservas();
      if (!datos || datos.length === 0) {
        alert('No hay reservas para exportar');
        return;
      }

      const headers = [
        { key: 'id', label: 'ID' },
        { key: 'fechaCreacion', label: 'Fecha de Solicitud' },
        { key: 'fecha', label: 'Fecha de Reserva' },
        { key: 'horaInicio', label: 'Hora Inicio' },
        { key: 'horaFin', label: 'Hora Fin' },
        { key: 'nombre', label: 'Solicitante' },
        { key: 'identificacion', label: 'Identificación' },
        { key: 'email', label: 'Email' },
        { key: 'telefono', label: 'Teléfono' },
        { key: 'academico', label: 'Programa' },
        { key: 'asignatura', label: 'Asignatura' },
        { key: 'capacidad', label: 'Capacidad' },
        { key: 'observaciones', label: 'Observaciones' },
        { key: 'equipos', label: 'Equipos' },
        { key: 'opcionales', label: 'Opcionales' }
      ];

      const escapeCell = (value) => {
        if (value === null || value === undefined) return '""';
        const str = String(value).replace(/"/g, '""');
        return `"${str}"`;
      };

      const rows = datos.map((r) => {
        const rowObj = {
          ...r,
          equipos: (r.equipos || []).join(', '),
          opcionales: (r.opcionales || []).join(', ')
        };
        return headers.map((h) => escapeCell(rowObj[h.key])).join(';');
      });

      const headerLine = headers.map((h) => escapeCell(h.label)).join(';');
      const csv = [headerLine, ...rows].join('\r\n');
      const bom = '\uFEFF';
      const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const ts = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
      link.download = `reservas-auditorio-${ts}.csv`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error exportando CSV:', err);
      alert('Error exportando CSV');
    }
  };

  return (
    <div className="admin-reporte-container">
      <header className="admin-header">
        <h1>Panel de Reporte - Reservas de Auditorios</h1>
        <div className="admin-nav">
          <button onClick={() => onNavigate('reserva')} className="nav-button">
            Página de Reservas
          </button>
          <button onClick={onLogout} className="logout-button">
            Cerrar Sesión
          </button>
        </div>
      </header>

      <div className="admin-content">
        <div className="filtros-container">
          <h2>Filtros</h2>
          <div className="filtro-grupo">
            <label>Email del solicitante:</label>
            <input
              type="text"
              value={filtroEmail}
              onChange={(e) => setFiltroEmail(e.target.value)}
              list="email-options"
              placeholder="Escribe o selecciona un email"
            />
            <datalist id="email-options">
              {emailsUnicos.map((email) => (
                <option key={email} value={email} />
              ))}
            </datalist>
            {filtroEmail && (
              <button
                className="limpiar-filtro"
                onClick={() => setFiltroEmail('')}
              >
                ×
              </button>
            )}
          </div>
          <div className="filtro-grupo">
            <label>Fecha de solicitud desde:</label>
            <input 
              type="date" 
              value={filtroFechaDesde} 
              onChange={(e) => setFiltroFechaDesde(e.target.value)}
            />
            {filtroFechaDesde && (
              <button 
                className="limpiar-filtro" 
                onClick={() => setFiltroFechaDesde('')}
              >
                ×
              </button>
            )}
          </div>
          
          <div className="filtro-grupo">
            <label>Fecha de solicitud hasta:</label>
            <input 
              type="date" 
              value={filtroFechaHasta} 
              onChange={(e) => setFiltroFechaHasta(e.target.value)}
            />
            {filtroFechaHasta && (
              <button 
                className="limpiar-filtro" 
                onClick={() => setFiltroFechaHasta('')}
              >
                ×
              </button>
            )}
          </div>
          
          <button 
            className="refresh-button" 
            onClick={cargarReservas}
            disabled={cargando}
          >
            {cargando ? 'Cargando...' : 'Actualizar'}
          </button>
        </div>

        <div className="tabla-container">
          <h2>Listado de Reservas</h2>
          <div style={{ marginBottom: '10px' }}>
            <button 
              className="refresh-button" 
              onClick={descargarExcel}
              disabled={cargando || reservasFiltradas.length === 0}
            >
              Descargar Excel
            </button>
          </div>
          
          {error && <div className="error-mensaje">{error}</div>}
          
          {cargando ? (
            <div className="cargando">Cargando reservas...</div>
          ) : reservasFiltradas.length === 0 ? (
            <div className="sin-resultados">No se encontraron reservas con los filtros seleccionados</div>
          ) : (
            <table className="tabla-reservas">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Fecha de Solicitud</th>
                  <th>Fecha de Reserva</th>
                  <th>Horario</th>
                  <th>Solicitante</th>
                  <th>Email</th>
                  <th>Programa</th>
                  <th>Capacidad</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {reservasFiltradas.map(reserva => (
                  <tr key={reserva.id}>
                    <td>{reserva.id}</td>
                    <td>{formatearFecha(reserva.fechaCreacion)}</td>
                    <td>{reserva.fecha}</td>
                    <td>{reserva.horaInicio} - {reserva.horaFin}</td>
                    <td>{reserva.nombre}</td>
                    <td>{reserva.email}</td>
                    <td>{reserva.academico}</td>
                    <td>{reserva.capacidad}</td>
                    <td>
                      <button 
                        className="ver-detalles-btn"
                        onClick={() => alert(`Detalles de la reserva ${reserva.id}\n\nSolicitante: ${reserva.nombre}\nEmail: ${reserva.email}\nTeléfono: ${reserva.telefono}\nPrograma: ${reserva.academico}\nAsignatura: ${reserva.asignatura}\nFecha de solicitud: ${formatearFecha(reserva.fechaCreacion)}\nFecha de reserva: ${reserva.fecha}\nHorario: ${reserva.horaInicio} - ${reserva.horaFin}\nCapacidad: ${reserva.capacidad}\nObservaciones: ${reserva.observaciones}\n\nEquipos: ${reserva.equipos.join(', ')}\nOpcionales: ${reserva.opcionales.join(', ')}`)}
                      >
                        Ver detalles
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
}